import styled from "styled-components";

export const GradientStopSvgDefaultBox = styled.stop<{stopOpacity: number}>`
    stop-color: ${({theme}) => theme.colors.brandPrimary};
    stop-opacity: ${props=> props.stopOpacity};
`;
